<template>
  <requiring-user>

    <h1 class="page-title">{{ $t('blackboard.title') }}</h1>

    <form-container size="medium" v-for="project in projects" :key="project.id">
      <ul class="project-list">
        <h2 class="project__title">{{project.name}}</h2>
        <hr class="project__separator">
        <li v-for="doc in project.documents" :key="doc.id" class="document">
          <a :href="doc.url" target="_blank" class="link">
            <div class="title">
              <div v-if="doc.path && doc.path.length > 0" class="path">
                <span v-for="(segment, index) in doc.path" :key="segment">
                  {{segment}}
                  <icon v-if="index != doc.path.length - 1" name="caret-right" class="path-separator"></icon>
                </span>
              </div>

              <div class="name">{{doc.name}}</div>

              <div v-if="doc.description" class="description">
                {{doc.description}}
              </div>
            </div>
            <span class="open">{{ $t('blackboard.performShow') }}</span>
          </a>
        </li>
      </ul>
    </form-container>

    <form-container size="medium" v-if="isLoading || errorMsg">
      <loading-indicator v-if="isLoading"/>
      <b-alert v-if="errorMsg" variant="danger" show>{{ errorMsg }}</b-alert>
    </form-container>

  </requiring-user>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BlackboardScreen',
  data () {
    return {
      isLoading: false,
      infoMsg: null,
      errorMsg: null
    }
  },
  computed: mapState({
    projects: state => state.blackboard || [
      {
        id: 'p01',
        name: 'Wohnen am Land',
        documents: [
          {
            id: 'd01',
            path: ['Ankündigungen'],
            name: 'Mieterversammlung 2018',
            description: 'Wir freuen uns, Sie zur jährlichen Mieterversammlung am 5. Mai einladen zu können. Details entnehmen Sie bitte dem PDF-Dokument.',
            date: '4. März 2018',
            url: 'https://picsum.photos/200/300/?random'
          },
          {
            id: 'd02',
            path: ['Internes', 'Hausordnung'],
            name: 'Sonderverordnung Rasenmähen',
            date: '13. Februar 2018',
            url: 'https://picsum.photos/200/300/?random'
          }
        ]
      },
      {
        id: 'p02',
        name: 'Wohnen in Lend',
        documents: [
          {
            id: 'd01',
            name: 'Nachmieter für TOP5 gesucht!',
            description: 'Sie kennen jemanden, der eine Wohung sucht? Gerade ist eine wunderschöne Dachwohnung in "Wohnen am Land" frei geworden. Details im Anhang.',
            date: '12. Februar 2018',
            url: 'https://picsum.photos/200/300/?random'
          },
          {
            id: 'd02',
            path: ['Ankündigungen'],
            name: 'Stromablesetermine 2018',
            date: '18. Jänner 2018',
            url: 'https://picsum.photos/200/300/?random'
          }
        ]
      }
    ]
  }),
  mounted () {
    if (!this.blackboard) {
      this.reload()
    }
  },
  methods: {
    async reload () {
      this.isLoading = true
      this.errorMsg = null

      try {
        await this.$store.dispatch('fetchBlackBoard')
      } catch (error) {
        this.errorMsg = error.message
      }

      this.isLoading = false
    }
  }

}
</script>

<style scoped>
.project-list {
  padding: 0;
}

.project__title {
  text-align: left;
  font-family: "Raleway", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

.project__separator {
}

.document {
  margin-bottom: 20pt;
  padding: 0;
  list-style-type: none;
  text-align: left;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 10pt;
  border-collapse: separate;
  border-color: rgba(255, 255, 255, 0.7);
  border-width: 1pt;
  border-style: solid;
}

.link {
  text-decoration: none;
  display: inline-block;
  padding: 20pt;
  width: 100%;
  height: 100%;
  flex-direction: column;
  display: flex;
}

@media only screen and (min-width: 600px) {
  .link {
    flex-direction: row;
    align-items: center;
  }
}

@media only screen and (min-width: 600px) {
  .title {
    flex: 80%;
  }
}

.path {
  color: #444;
  font-size: 0.6rem;
  text-transform: uppercase;
  margin-bottom: 5pt;
}

.path-separator {
  color: #444;

  width: auto;
  height: 0.7em;

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;

  padding-left: 3pt;
  padding-right: 3pt;
}

.name {
  font-size: 1.2rem;
  color: #333;
}

.description {
  margin-top: 15pt;
  font-size: 0.8rem;
  color: #444;
}

.open {
  padding: 5pt;
  margin-top: 15pt;
  text-align: center;
  color: white;
  background-color: rgba(0, 0, 200, 0.8);
  border-radius: 3pt;
  width: 100%;
}

.open:hover {
  color: rgb(0, 0, 200);
  background-color: rgba(0, 0, 200, 0.4);
}

@media only screen and (min-width: 600px) {
  .open {
    flex: 20%;
    margin-top: 0;
    margin-left: 10pt;
    width: auto;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlackboardScreen.vue